var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingapore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 512,
    viewBox: "0 0 513 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_103_10026)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_103_10026",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 513,
    height: 513
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.512939 0H512.469V512.029H0.512939V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_103_10026)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-19.5 0H748.507V512.029H-19.5V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-19.5 0H748.507V255.978H-19.5V0Z",
    fill: "#DF0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.654 42.9161C137.444 47.2465 119.339 58.3998 106.381 74.5027C93.4225 90.6057 86.4003 110.677 86.4935 131.346C86.5867 152.016 93.7897 172.023 106.893 188.008C119.996 203.994 138.2 214.983 158.449 219.131C144.815 223.121 130.441 223.889 116.46 221.373C102.479 218.857 89.2739 213.127 77.8864 204.634C66.4988 196.141 57.2405 185.119 50.8418 172.436C44.443 159.753 41.0789 145.757 41.0148 131.552C40.9508 117.346 44.1885 103.32 50.4726 90.5801C56.7567 77.84 65.9152 66.7345 77.2257 58.1396C88.5361 49.5447 101.689 43.6955 115.647 41.0536C129.605 38.4117 143.985 39.0493 157.654 42.9161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.443 117.332L112.788 107.362L129.766 107.217L134.968 91.1059L140.387 107.217H157.293L143.71 117.332L148.912 133.444L135.113 123.546L121.385 133.516L126.443 117.332ZM145.228 172.892L131.5 162.921L148.479 162.777L153.753 146.665L159.099 162.705H176.078L162.351 172.819L167.625 188.931L153.898 179.105L140.17 189.076L145.228 172.892ZM207.579 172.458L193.851 162.488L210.757 162.343L216.032 146.232L221.378 162.343H238.429L224.774 172.458L230.048 188.57L216.248 178.672L202.521 188.642L207.579 172.458ZM226.147 117.405L212.419 107.434L229.398 107.29L234.6 91.1781L240.018 107.217H256.925L243.342 117.332L248.544 133.444L234.744 123.618L221.017 133.588L226.147 117.405ZM176.8 80.9188L163.073 70.9484L180.052 70.8039L185.326 54.6924L190.672 70.8039H207.651L193.923 80.9188L199.198 96.958L185.47 87.1322L171.743 97.1025L176.8 80.9188Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_103_10026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingapore);
export default __webpack_public_path__ + "static/media/singapore.826bc37d27532ea32500538f3a5d689f.svg";
export { ForwardRef as ReactComponent };